import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import { ProgramFinancialBreakdown } from '../../../../../api/types/reports/finanace/program-breakdown/program-breakdown-income.type';
import { ProgramBreakdownFinancialIncomeReport } from '../../../../../api/types/reports/finanace/program-breakdown/incomes/program-financial-breakdown-incomes.type';
import { YearlyProgramExpenseReport } from '../../../../../api/types/reports/finanace/program-breakdown/incomes/program-financial-breakdown-expanses.type';

export const getProgramFinancialOperations = async (
  branchId: number,
  abstractProgramId: number,
  startYear: number,
  programId: number,
  setIncomes: (data: ProgramBreakdownFinancialIncomeReport) => any,
  setExpanses: (data: YearlyProgramExpenseReport) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    const programsFinancialRes = await appApi.getProgramComparisonByBranches2({
      branchId: branchId,
      programId: programId,
    });

    const programFinancial: ProgramFinancialBreakdown =
      programsFinancialRes.data.body;

    setIncomes(programFinancial.incomes);
    setExpanses(programFinancial.expanses);

    // http://localhost:3000/reports/finance/program-comparison-among-branches
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  }
};
